import React, { Fragment, useState, useEffect } from 'react'
import { /* useDispatch, */ useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Page from '@atlaskit/page'
import Button from '@atlaskit/button'
import { CONTROLLING_ENDPOINT } from 'config/server.config'
import { request } from 'utils/http.utils'

import modules from 'modules'
import TextField from '@atlaskit/textfield'

import { Field, FormFooter } from '@atlaskit/form'

import PageHeader from 'components/page-header.component'

const ControllingScreen: React.FunctionComponent = (): JSX.Element => {

  const history = useHistory()
  /* const dispatch = useDispatch() */

  const isAdminUser = useSelector(
    modules.auth.selectors.selectIsAdminUser,
  )

  const userPermissions = useSelector(
    modules.auth.selectors.selectUserPermissions,
  )

  useEffect(() => {
    if (!userPermissions?.includes('controllingViewPermission')) {
      if(isAdminUser) {
        //console.log("access ok.")
      }
      else {
        history.replace('')
      }
    }
  }, [isAdminUser, userPermissions])

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsLoading(true)
    setError(null)

    try {
      const response = await request({
        url: CONTROLLING_ENDPOINT,
        method: 'POST',
        data: new FormData(event.currentTarget),
        responseType: 'blob',
        // Spreadsheet matching runs well beyond the default request timeout.
        timeout: 120000,
      })

      const url = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = url
      link.download = 'Auswertung.zip'
      link.click()
      URL.revokeObjectURL(url)
    } catch (e) {
      setError('Die Auswertung ist fehlgeschlagen. Bitte die Dateien prüfen.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Page>
      <PageHeader title="Abrechnungsprüfung" breadcrump="Abrechnungsprüfung" />
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <Field name="wiegedaten" label="Wiegedaten" isRequired>
          {() => (
            <Fragment>
              <TextField type="file" name="wiegedaten" />
            </Fragment>
          )}
        </Field>

        <Field name="artikelauswertung" label="Artikelauswertung" isRequired>
          {() => (
            <Fragment>
              <TextField type="file" name="artikelauswertung" />
            </Fragment>
          )}
        </Field>

        {error && <p className="text-red">{error}</p>}

        <FormFooter>
          <Button type="submit" appearance="primary" isDisabled={isLoading}>
            Auswerten
          </Button>
        </FormFooter>
      </form>
    </Page>
  )
}

export default ControllingScreen
